/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import dayjs from 'dayjs'
import { BET_HIT_STATE } from 'adv-protocol/src/GameCommon'
import { Schema$CompanyPick } from '@interface/company-pick'
import { FEED_SUPPLIER } from '@v2/constants/common'
import {
  LS_REGULAR_ODDS_HANDICAP,
  LS_REGULAR_ODDS_UNDEROVER,
  UNIFIED_REGULAR_ODDS_HANDICAP,
  UNIFIED_REGULAR_ODDS_UNDEROVER,
} from '@game-type/game-market-types'
// css
import * as _ from 'lodash'
import { CompanyPickDetailContentsWrap } from '../index.style'
import CompanyPickImagePopup from './CompanyPickImagePopup'
import HomeTagImg from '@assets/images/icon/matchup_icon/home-tag-ico.png'
import { BASIC_TEAM_EMBLEM_MAP } from '@shared/EmblemGroup'
import useRootStore from '@store/useRootStore'
import { replaceMarketName } from '@game/util'

interface CompanyPickDetailProps {
  companyPick: Schema$CompanyPick
  managerUserPromiseId?: string
}

export const CompanyPickDetailContents: React.FC<CompanyPickDetailProps> = observer((props: CompanyPickDetailProps) => {
  const { companyPickStore, globalStore } = useRootStore()
  const { companyPick } = props
  const {
    title,
    content = '',
    homeTeamName,
    awayTeamName,
    homeTeamEmblem,
    awayTeamEmblem,
    specialBetValue,
    selectionName,
    marketType,
    marketName,
    outcomeRate,
    hitState,
    feedSupplier,
  } = companyPick

  // img
  const imageUrl = globalStore.getIngameImagesUrl()
  const IMAGE_DEFAULT_URL = `${imageUrl}bg/default_img.jpg`


  const [visibleContent, setVisibleContent] = useState(false)
  const [companyPickImageSrc, setCompanyPickImageSrc] = useState(null)

  useEffect(() => {
    const elems = document.querySelectorAll('.pick-box img')
    _.forEach(elems, elem => {
      if (elem.className.indexOf('cursor-pointer') < 0) {
        elem.className += ' cursor-pointer'
      }
      elem.addEventListener('click', showCompanyPickImagePopup)
    })

  }, [content])

  let hitStateElement
  switch (hitState) {
    case BET_HIT_STATE.SUCCESS:
      hitStateElement = <span className="success state"/>
      break
    case BET_HIT_STATE.FAIL:
      hitStateElement = <span className="fail state"/>
      break
    case BET_HIT_STATE.CANCEL:
      hitStateElement = <span className="cancel state"/>
      break
    default:
      break
  }

  const handicapElement = <span className="market-type">H</span>
  const underOverElement = <span className="market-type">U/O</span>

  let marketTypeElement
  if (feedSupplier === FEED_SUPPLIER.BET_RADAR) {
    if (UNIFIED_REGULAR_ODDS_HANDICAP.indexOf(marketType) >= 0) {
      marketTypeElement = handicapElement
    } else if (UNIFIED_REGULAR_ODDS_UNDEROVER.indexOf(marketType) >= 0) {
      marketTypeElement = underOverElement
    }
  } else if (feedSupplier === FEED_SUPPLIER.LSPORTS) {
    if (LS_REGULAR_ODDS_HANDICAP.indexOf(marketType) >= 0) {
      marketTypeElement = handicapElement
    } else if (LS_REGULAR_ODDS_UNDEROVER.indexOf(marketType) >= 0) {
      marketTypeElement = underOverElement
    }
  }

  const showCompanyPickImagePopup = (event) => {
    setCompanyPickImageSrc(event.target.src)
    setVisibleContent(true)
  }
  const manager
    = _.find(companyPickStore.companyPickManagers, manager => manager.userPromiseId === companyPick.userPromiseId)

  return (
    <Fragment>
      <CompanyPickDetailContentsWrap>
        <div className="team-info-box">
        <span className="team-info-box--item">
          <img src={homeTeamEmblem || BASIC_TEAM_EMBLEM_MAP[companyPick.sportId]} alt="홈팀 엠블럼" className="emblem"/>
          <span className="team">{homeTeamName}</span>
          <img src={HomeTagImg} alt="홈팀" className="home-tag-img"/>
        </span>
          <span className="team-info-box--item">
          <div className="vs-bg">VS</div>
          <span className="date">{dayjs(companyPick.dateOfMatch).format('MM/DD')}</span>
          <span>{dayjs(companyPick.dateOfMatch).format('HH:mm')}</span>
        </span>
          <span className="team-info-box--item">
          <img src={awayTeamEmblem || BASIC_TEAM_EMBLEM_MAP[companyPick.sportId]} alt="원정팀 엠블럼" className="emblem"/>
          <span className="team">{awayTeamName}</span>
        </span>
        </div>

        <div className="pick-box">
          <h4 className="tit">{title}</h4>
          <p className="txt">
            <span dangerouslySetInnerHTML={{ __html: `${content}` }}/>
            {companyPick.contentImageUrl && (
              <img src={companyPick.contentImageUrl} alt="예측 이미지"/>)}
          </p>
          <span className="line"/>

          <p className="notice-txt">본 분석정보는 픽스터의 개인적 의견일 뿐이며,<br/>경기 결과에 따른 득실의 책임은 유저에게 있습니다.</p>
        </div>

        <div className="pick-item">
          <span className="pick-item--bg">
            <img src={manager?.detailPageCharacterImageUrl || IMAGE_DEFAULT_URL} alt={`${manager?.userNick} 캐릭터`}/>
          </span>
          <div className="pick-info">
            <div className="left">
              <span className="market-name">{replaceMarketName(marketName, homeTeamName, awayTeamName)}</span>
              <span className="outcome">{selectionName}</span>
              <div className="market-type-wrap">
                {marketTypeElement}
                <span className="bet-point">{specialBetValue}</span>
              </div>
            </div>

            <div className="right">
              <span className="rate">{outcomeRate}</span>
              {hitStateElement}
            </div>
          </div>
        </div>
      </CompanyPickDetailContentsWrap>

      {/* 프리미엄 분석가 경기분석 이미지 확대 팝업 */}
      <CompanyPickImagePopup visible={visibleContent} setVisible={setVisibleContent}
                             imgSrc={companyPickImageSrc}/>
    </Fragment>
  )
})
